import { useContext } from 'react';
import { KameleoonFeaturesContext } from '../context';

export const useKameleoonState = () => {
    const context = useContext(KameleoonFeaturesContext);

    if (!context) {
        throw new Error(`Hook should be used within context provider`);
    }

    return context;
};
